import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'

const initialState = {
  rowData: []
}

const companiesReducer = createReducer(initialState, {
  [ACT.COMPANIES_FETCH_SUCCESS](state, action) {
    const { rowData } = action.payload
    return {
      ...state,
      rowData
    }
  },
  [ACT.COMPANY_CREATE_SUCCESS](state, action) {
    const { company } = action.payload
    return update(state, {
      rowData: { $push: [company] }
    })
  }
})

export default companiesReducer
